import { Injectable } from '@angular/core';
import { Camera, ImageOptions, Photo } from '@capacitor/camera';

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  constructor() {}

  public async getPhoto(options: ImageOptions): Promise<Photo> {
    return await Camera.getPhoto(options);
  }
}
